import script from "./StartWithMcpDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./StartWithMcpDialog.vue?vue&type=script&setup=true&lang=js"

import "./StartWithMcpDialog.vue?vue&type=style&index=0&id=1f7fdf7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f7fdf7c"]])

export default __exports__